import React from 'react'
import { connect } from 'react-redux'
import './PlayerAnalytics.css'
import { loadPlayer } from '../../actions'

import get from 'lodash/get'

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

class PlayerAnalytics extends React.Component {

  render() {
    const { player } = this.props
    if(!player) {
      return <div>Loading player info...</div>
    }

    return (
      <div className="analytics-page player-analytics-page container">
        <div className="hbox row">
          <div className="card-box hbox--flex">
            <h4 className="chart-title">Sports</h4>
            <ResponsiveContainer height={300} width='100%'>
              <BarChart width={600} height={300} data={get(player, 'analytics.sport', [])}>
                <XAxis dataKey="name"/>
                <YAxis/>
                <CartesianGrid strokeDasharray="1 1"/>
                <Tooltip/>
                <Bar dataKey="value" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="card-box hbox--flex">
            <h4 className="chart-title">Countries</h4>
            <ResponsiveContainer height={300} width='100%'>
              <BarChart width={600} height={300} data={get(player, 'analytics.country', [])}>
                <XAxis dataKey="name"/>
                <YAxis/>
                <CartesianGrid strokeDasharray="1 1"/>
                <Tooltip/>
                <Bar dataKey="value" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="hbox row">
          <div className="card-box hbox--flex">
            <h4 className="chart-title">Tournaments</h4>
            <ResponsiveContainer height={300} width='100%'>
              <BarChart width={600} height={300} data={get(player, 'analytics.league', [])}>
                <XAxis dataKey="name"/>
                <YAxis/>
                <CartesianGrid strokeDasharray="1 1"/>
                <Tooltip/>
                <Bar dataKey="value" fill="#8884d8" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state, ownProps) => ({
    playerId: ownProps.params.playerId,
    player: state.entities.players[ownProps.params.playerId],
  }), 
  { loadPlayer }
)(PlayerAnalytics)


// WEBPACK FOOTER //
// ./src/components/Players/PlayerAnalytics.js